import { gql } from 'graphql.macro';

export const GetSheqManagerLookup = gql`
  query sheqManagers {
    sheqManagers: sHEQManagers {
      employeeId
      displayName
    }
  }
`;